module.exports = __webpack_public_path__ + "static/media/breakdownTable3_mobile.7ff418d8.png";